"use client";

import Image from "next/image";

const partners = [
  { name: "Spie Batignolles", logo: "/partners/spie-batignolles.svg" },
  { name: "Legendre", logo: "/partners/legendre.jpg" },
  { name: "Demathieu Bard", logo: "/partners/demathieu-bard.svg" },
  { name: "Colas", logo: "/partners/colas.svg" },
  { name: "Eiffage", logo: "/partners/eiffage.jpg" },
  { name: "Bouygues", logo: "/partners/bouygues.svg" },
];

export function PartnersSection() {
  return (
    <section className="py-12 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-bold text-center mb-8">
          Ils nous font confiance
        </h2>
      </div>

      {/* Carrousel infini */}
      <div className="container mx-auto px-4 overflow-hidden">
        <div className="flex animate-scroll">
          {/* Double les logos pour créer l'effet infini */}
          {[...partners, ...partners, ...partners].map((partner, index) => (
            <div
              key={`${partner.name}-${index}`}
              className="flex-shrink-0 mx-8"
            >
              <div className="h-16 w-40 relative">
                <Image
                  src={partner.logo}
                  alt={partner.name}
                  fill
                  className="object-contain"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }
        .animate-scroll {
          animation: scroll 7s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}
